export default class CpfHelper {
    constructor() {
        throw 'Não é possível instanciar CpfHelper';
    }

    static testaCpf(strCPF) {
        let soma;
        let resto;
        let digito;
        let i;
        soma = 0;
        digito = 0;

        if(!strCPF) return false;

        for (i = 1; i < 11; i++) {
            if (i === 1) {
                parseInt(strCPF.substring(i-1, i)) === parseInt(strCPF.substring(i, i+1)) ?
                digito = parseInt(strCPF.substring(i-1, i)) :
                i = 12
            } else {
                parseInt(strCPF.substring(i-1, i)) === digito ?
                digito = parseInt(strCPF.substring(i-1, i)) :
                i = 12
            }
        }
        if (i === 11) return false;

        for (i = 1; i <= 9; i++) soma = soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
        resto = (soma * 10) % 11;

        if ((resto == 10) || (resto == 11))  resto = 0;
        if (resto != parseInt(strCPF.substring(9, 10)) ) return false;

        soma = 0;
        for (i = 1; i <= 10; i++) soma = soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
        resto = (soma * 10) % 11;

        if ((resto == 10) || (resto == 11))  resto = 0;
        if (resto != parseInt(strCPF.substring(10, 11) ) ) return false;
        return true;
    }

    static cpfFormatado(cpf) {
        if(cpf && cpf.length < 14) {
            return cpf.slice(0, 3) + '.' + cpf.slice(3, 6) + '.' + cpf.slice(6, 9) + '-' + cpf.slice(9)
        } else {
            return cpf
        }
    }
}



// WEBPACK FOOTER //
// ./src/helpers/CpfHelper.js